<template>
  <div class="ant-pro-multi-tab">
    <div class="ant-pro-multi-tab-wrapper">
      <a-tabs
          hideAdd
          type="editable-card"
          v-model:activeKey="activeKey"
          :tabBarStyle="{paddingLeft: '16px', paddingTop: '1px', marginBottom: '16px'}"
          @edit="onEdit"
          @change="changeTab"
      >
        <a-tab-pane
            v-for="page in pages"
            :key="page.fullPath"
            :closable="pages.length > 1"
            style="height: 0"
        >
          <template #tab>
            <a-dropdown :trigger="['contextmenu']">
              <span :style="{ userSelect: 'none' }">{{ page.meta.customTitle || page.meta.title }}</span>
            </a-dropdown>
          </template>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import './MultiTab.less'
import {reactive, ref, watch} from "vue";
import {useRouter} from "vue-router";
import events from '@/utils/eventBus'
import {message} from 'ant-design-vue';

export default {
  name: "MultiTab",
  setup() {
    let fullPathList = []
    let pathList = []
    const pages = reactive([])
    const activeKey = ref('')
    const router = useRouter()

    const selectedLastPath = () => {
      activeKey.value = fullPathList[fullPathList.length - 1]
    }
    pages.push(router.currentRoute.value)
    fullPathList.push(router.currentRoute.value.fullPath)
    pathList.push(router.currentRoute.value.path)
    selectedLastPath()
    const onEdit = (targetKey, action) => {
      if (action === 'remove') {
        remove(targetKey);
      }
    }
    const remove = (targetKey) => {
      const temp = pages.filter((page) => page.fullPath !== targetKey)
      pages.length = 0
      pages.push(...temp)
      fullPathList = fullPathList.filter((path) => path !== targetKey)
      if (targetKey.includes('?')) {
        const params = targetKey.split('?');
        pathList = pathList.filter((path) => path !== params[0]);
      } else {
        pathList = pathList.filter((path) => path !== targetKey);
      }
      // 判断当前标签是否关闭，若关闭则跳转到最后一个还存在的标签页
      if (!fullPathList.includes(activeKey.value)) {
        selectedLastPath();
        changeTab(activeKey.value);
      }
    }

    // content menu
    const closeSelf = (e) => {
      // 判断是否为最后一个标签页，如果是最后一个，则无法被关闭
      if (fullPathList.length > 1) {
        remove(e)
      } else {
        message.info('这是最后一个标签了, 无法被关闭')
      }
    }
    const closeLeft = (e) => {
      const currentIndex = fullPathList.indexOf(e)
      if (currentIndex > 0) {
        fullPathList.forEach((item, index) => {
          if (index < currentIndex) {
            remove(item);
          }
        })
      } else {
        message.info('左侧没有标签');
      }
    }
    const closeRight = (e) => {
      const currentIndex = fullPathList.indexOf(e)
      if (currentIndex < fullPathList.length - 1) {
        fullPathList.forEach((item, index) => {
          if (index > currentIndex) {
            remove(item);
          }
        })
      } else {
        message.info('右侧没有标签');
      }
    }
    const closeAll = (e) => {
      const currentIndex = fullPathList.indexOf(e)
      fullPathList.forEach((item, index) => {
        if (index !== currentIndex) {
          remove(item)
        }
      })
    }

    watch(
        () => router.currentRoute.value,
        (newVal) => {
          console.log("router change set activeKey : %o", newVal);
          activeKey.value = newVal.fullPath
          const index = pathList.indexOf(newVal.path);
          if (index < 0) {
            pathList.push(newVal.path);
            fullPathList.push(newVal.fullPath)
            pages.push(newVal)
          } else {
            fullPathList.splice(index, 1, newVal.fullPath)
            pages.splice(index, 1, newVal)
          }
        }
    )

    const changeTab = (changeKey) => {
      if (changeKey.indexOf('?') !== -1) {
        const paths = changeKey.split('?');
        const queryList = paths[1].split('&');
        const params = {}
        queryList.forEach(item => {
          const tmp = item.split('=');
          params[tmp[0]] = tmp[1];
        })
        console.log("multitab change, path:%s, params:%o", paths[0], params);
        router.push({
          path: paths[0],
          query: params
        })
      } else {
        router.push({path: changeKey})
      }
    }

    events.on('closeCurrentTab', () => {
      console.log('<#> close current Tab event');
      if (fullPathList.length > 1) {
        remove(activeKey.value);
      }
    })

    return {
      fullPathList,
      pages,
      activeKey,
      onEdit,
      remove,
      selectedLastPath,
      closeSelf,
      closeLeft,
      closeRight,
      closeAll,
      changeTab
    }
  }
}
</script>

<style scoped lang="less">
.tab_style() {
  .ant-tabs-card-bar {
    padding-left: 0;

    .ant-tabs-nav-container {
      .ant-tabs-tab-prev:hover,
      .ant-tabs-tab-next:hover {
        // width: 22px;
        background-color: rgba(0, 0, 0, 0.03);
      }

      font-size: 13px;
      height: 39px;
    }

    .ant-tabs-tab {
      margin-right: 0;
      border-radius: 0px;
      border-top: 0px;
      line-height: 40px;

      .anticon-close {
        display: none;
      }
    }

    .ant-tabs-tab-active {
      padding-bottom: 0px;
      background-color: rgba(0, 0, 0, 0.1);

      .anticon-close {
        display: inline-block;
      }
    }

    .ant-tabs-tab:hover {
      padding-left: 20px;
      padding-right: 20px;

      .anticon-close {
        color: #333;
        display: inline-block;
      }
    }
  }
}

.ant-pro-multi-tab-wrapper {
  .tab_style
  () !important;
}
</style>